import type { CreateNewCandidateSchedulePayload } from "@/api/schedule/models";
import { convertTrimToUndefined, toDigitsOnly } from "@/utils";
import { mapTalentOrigin, type VisualTalentOrigin } from "@/utils/features/schedule/options";

interface NewCandidateScheduleValues {
  scheduleDate: Date | string | null;
  scheduleTime: string;
  candidateFullName: string;
  candidateBirthday: Date | string | null;
  candidateOrigin: VisualTalentOrigin;
  candidateEmail: string;
  candidatePhone: string;
  candidateSecondaryPhone: string;
  responsibleFullName: string;
  responsibleEmail: string;
  responsiblePhone: string;
  responsibleSecondaryPhone: string;
  isMinor: boolean;
}

export function buildNewCandidateSchedulePayload(
  values: NewCandidateScheduleValues,
): CreateNewCandidateSchedulePayload {
  const scheduleDate = new Date(values.scheduleDate as Date | string);
  const [hours, minutes] = values.scheduleTime.split(":").map(Number);
  scheduleDate.setHours(hours, minutes, 0, 0);

  const candidate = {
    fullName: values.candidateFullName.trim(),
    birthday: new Date(values.candidateBirthday as Date | string),
    origin: mapTalentOrigin(values.candidateOrigin),
    email: convertTrimToUndefined(values.candidateEmail),
    phone: convertTrimToUndefined(toDigitsOnly(values.candidatePhone)),
    secondaryPhone: convertTrimToUndefined(toDigitsOnly(values.candidateSecondaryPhone)),
  };

  if (values.isMinor) {
    return {
      scheduleDate,
      candidate: {
        fullName: candidate.fullName,
        birthday: candidate.birthday,
        origin: candidate.origin,
        responsible: {
          fullName: values.responsibleFullName.trim(),
          email: values.responsibleEmail.trim(),
          phone: toDigitsOnly(values.responsiblePhone),
          secondaryPhone: convertTrimToUndefined(toDigitsOnly(values.responsibleSecondaryPhone)),
        },
      },
    };
  }

  return { scheduleDate, candidate };
}
